import type { SVGProps } from "react";

interface LogoProps extends SVGProps<SVGSVGElement> {
  title?: string;
}

function Logo({ title, ...props }: LogoProps) {
  return (
    <svg
      height="46.275"
      viewBox="0 0 179.142 46.275"
      width="179.142"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title && <title>{title}</title>}
      <defs>
        <style>
          {
            ".geopsui.logo .a,.geopsui .c{fill:#6987a1;} .geopsui.logo .b{fill:#76b833;} .geopsui.logo .c{fill-rule:evenodd;} .geopsui.logo .d{fill:none;}"
          }
        </style>
      </defs>
      <g className="geopsui logo" transform="translate(-140 -35)">
        <path
          className="a"
          d="M619.312,193.909a2.743,2.743,0,1,1-2.745,2.743A2.748,2.748,0,0,1,619.312,193.909Z"
          transform="translate(-394.171 -137.898)"
        />
        <path
          className="b"
          d="M566.107,92.795c8.586.262,15.63-8.894,13.154-17.121-1.926-7.462-10.762-12.269-18.066-9.2-7.276,2.652-11.075,12.1-7.214,18.932A13.712,13.712,0,0,0,566.107,92.795Zm-.514,4.577c-10.38.044-19.176-10.228-17.588-20.487,1.058-9.951,11.407-17.65,21.287-15.64,9.679,1.6,16.9,11.9,14.649,21.576C582.311,91.193,574.2,97.8,565.593,97.372Z"
          transform="translate(-336.284 -25.924)"
        />
        <path
          className="c"
          d="M117.979,104.82H105.111c-5.545,0-10.059,3.829-10.059,8.536v10.454c0,4.707,4.514,8.536,10.059,8.536H124.12v3.277c0,2.548-2.754,4.621-6.141,4.621l-19.4,0-1.22,0v.026c-.057,0-.11-.017-.167-.017a1.951,1.951,0,1,0,0,3.9c.057,0,.11-.014.167-.017v.023l20.618,0c5.547,0,10.059-3.829,10.059-8.536V113.356C128.037,108.649,123.526,104.82,117.979,104.82Zm6.141,23.612H105.111c-3.386,0-6.141-2.073-6.141-4.621V113.356c0-2.549,2.755-4.622,6.141-4.622h12.868c3.387,0,6.141,2.073,6.141,4.622Z"
          transform="translate(44.948 -62.885)"
        />
        <path
          className="c"
          d="M355.729,120.567v-7.211c0-4.707-4.512-8.536-10.057-8.536H332.8c-5.547,0-10.058,3.829-10.058,8.536v10.454c0,4.707,4.511,8.536,10.058,8.536H353.77a1.957,1.957,0,1,0,0-3.915H332.8c-3.385,0-6.14-2.073-6.14-4.621v-3.264ZM332.8,108.735h12.869c3.385,0,6.14,2.073,6.14,4.622v3.276H326.663v-3.276C326.663,110.807,329.417,108.735,332.8,108.735Z"
          transform="translate(-146.771 -62.885)"
        />
        <path
          className="c"
          d="M817.7,104.82H804.832c-5.547,0-10.059,3.829-10.059,8.536v28.516a1.959,1.959,0,0,0,3.918,0v-9.526H817.7c5.547,0,10.059-3.829,10.059-8.536V113.356C827.759,108.649,823.246,104.82,817.7,104.82Zm-19.009,8.536c0-2.549,2.754-4.622,6.141-4.622H817.7c3.386,0,6.142,2.073,6.142,4.622v10.454c0,2.548-2.756,4.621-6.142,4.621H798.691Z"
          transform="translate(-544.222 -62.885)"
        />
        <path
          className="c"
          d="M1045.163,116.453a.985.985,0,0,0-.136-.012l-.175,0a1.083,1.083,0,0,0-.234,0h-10.527l0-.007-6.7,0a3.907,3.907,0,0,1-.049-7.814h23.2a1.958,1.958,0,1,0,0-3.914l-23.149,0a7.822,7.822,0,0,0-.052,15.643l10.348.006h7.183a3.976,3.976,0,0,1-.19,7.948h-.006l-23.133,0a1.957,1.957,0,1,0,0,3.915h22.815a.194.194,0,0,0,.08-.009l.1.006c.065,0,.131.01.2.01a7.889,7.889,0,0,0,.421-15.768Zm-.421.372"
          transform="translate(-733.502 -62.789)"
        />
        <rect
          className="d"
          height="39.357"
          transform="translate(140 41.917)"
          width="179.142"
        />
      </g>
    </svg>
  );
}

export default Logo;
